import Fade from "@material-ui/core/Fade";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import classNames from "classnames";
import React, { Fragment } from "react";
import { RouteComponentProps, withRouter } from "react-router";
import IsVisSPCContext from "../../../componentes/CRUD/isVisContext";
import Header from "../../../componentes/Header/Header";
import Sidebar from "../../../componentes/Sidebar/Sidebar";
import styles from "../appStyles-jss";
import Decoration from "../Decoration";

interface Props extends RouteComponentProps {
  classes: any;
  children: any;
  history: any;
  loadTransition?: any;
  changeMode?: any;
  pageLoaded?: any;
  mode: any;
  gradient: any;
  deco: any;
  bgPosition: any;
  transform: any;
  place: any;
  titleException: any;
  handleOpenGuide?: any;
  isComplete?: boolean;
}

interface State {
  sidebarOpen: boolean;
  sidebarHover: boolean;
}

const DURACAO_DRAWER = 300;
// passagens rapidas do ponteiro pelo rail nao devem abrir o menu
const ESPERA_HOVER_SIDEBAR = 150;

const CONSULTA_SIDEBAR_FIXA = "(min-width: 1280px)";

const temSidebarFixa = () =>
  typeof window.matchMedia === "function" && window.matchMedia(CONSULTA_SIDEBAR_FIXA).matches;

class LeftSidebarLayout extends React.Component<Props, State> {
  static contextType = IsVisSPCContext;
  context!: React.ContextType<typeof IsVisSPCContext>;
  private avisoRedimensionamento = 0;
  private esperaHoverSidebar = 0;
  private pararDeOuvirBreakpoint = () => {};
  constructor(props: Props) {
    super(props);

    this.state = {
      sidebarOpen: !temSidebarFixa(),
      sidebarHover: false,
    };
  }

  toggleDrawerOpen = () => this.setState((prevState) => ({ sidebarOpen: !prevState.sidebarOpen }));

  componentDidMount() {
    if (typeof window.matchMedia !== "function") {
      return;
    }
    const consulta = window.matchMedia(CONSULTA_SIDEBAR_FIXA);
    if (typeof consulta.addEventListener === "function") {
      consulta.addEventListener("change", this.aoTrocarBreakpoint);
      this.pararDeOuvirBreakpoint = () => consulta.removeEventListener("change", this.aoTrocarBreakpoint);
    } else if (typeof consulta.addListener === "function") {
      consulta.addListener(this.aoTrocarBreakpoint);
      this.pararDeOuvirBreakpoint = () => consulta.removeListener(this.aoTrocarBreakpoint);
    }
  }

  // sidebarOpen tem sentido invertido no drawer temporario (false = aberto), entao ao cruzar
  // o breakpoint (zoom, redimensionar) o estado anterior abriria o menu sozinho
  aoTrocarBreakpoint = () => {
    window.clearTimeout(this.esperaHoverSidebar);
    this.setState({ sidebarOpen: !temSidebarFixa(), sidebarHover: false });
  };

  componentDidUpdate(_props: Props, estadoAnterior: State) {
    // abrir/fechar pelo hamburguer troca a largura do main sem transicao propria, entao o
    // transitionend do <main> nao cobre esse caso. O aviso precisa esperar a animacao do
    // drawer terminar, senao o Highcharts remede com a largura anterior.
    if (estadoAnterior.sidebarOpen !== this.state.sidebarOpen) {
      window.clearTimeout(this.avisoRedimensionamento);
      this.avisoRedimensionamento = window.setTimeout(
        () => window.dispatchEvent(new Event("resize")),
        DURACAO_DRAWER
      );
    }
  }

  componentWillUnmount() {
    this.pararDeOuvirBreakpoint();
    window.clearTimeout(this.avisoRedimensionamento);
    window.clearTimeout(this.esperaHoverSidebar);
  }

  // abaixo de lg a sidebar permanente da lugar ao drawer temporario: nao ha rail para
  // expandir, e o estado ficaria preso caso o ponteiro saisse sem disparar o mouseleave
  definirHoverSidebar = (sidebarHover: boolean) => {
    window.clearTimeout(this.esperaHoverSidebar);
    if (sidebarHover && temSidebarFixa()) {
      this.esperaHoverSidebar = window.setTimeout(() => this.setState({ sidebarHover: true }), ESPERA_HOVER_SIDEBAR);
    } else {
      this.setState({ sidebarHover: false });
    }
  };

  // Highcharts so refaz o layout no resize da janela; sem isso o grafico mantem a largura
  // anterior a expansao da sidebar e perde a ultima coluna.
  aoTerminarTransicao = (evento: React.TransitionEvent<HTMLElement>) => {
    if (evento.target === evento.currentTarget && evento.propertyName === "padding-left") {
      window.dispatchEvent(new Event("resize"));
    }
  };

  render() {
    const {
      classes,
      children,
      loadTransition,
      mode,
      gradient,
      deco,
      history,
      bgPosition,
      changeMode,
      transform,
      place,
      titleException,
      handleOpenGuide,
      isComplete = true
    } = this.props;
    return (
      <Fragment>
        <Header
          toggleDrawerOpen={this.toggleDrawerOpen}
          turnDarker={transform > 30}
          showTitle={transform > 40}
          margin={this.state.sidebarOpen || this.state.sidebarHover}
          menuFixoEsquerda={!this.state.sidebarOpen && this.state.sidebarHover}
          gradient={gradient}
          position="left-sidebar"
          changeMode={changeMode}
          mode={mode}
          title={place}
          history={history}
          openGuide={handleOpenGuide}
          isComplete={isComplete}
        />
        {isComplete && <IsVisSPCContext.Consumer>
          {(value) => {
            if (value && value.isVisSPC === "vis") {
              return null;
            }
            return (
              <Sidebar
                toggleDrawerOpen={this.toggleDrawerOpen}
                open={this.state.sidebarOpen}
                expandidoPorHover={this.state.sidebarHover}
                aoEntrarMouse={() => this.definirHoverSidebar(true)}
                aoSairMouse={() => this.definirHoverSidebar(false)}
                loadTransition={loadTransition}
                turnDarker={transform > 30}
                leftSidebar
              />
            );
          }}
        </IsVisSPCContext.Consumer>}
        <main
          className={classNames(
            classes.content,
            !this.state.sidebarOpen && (!this.context?.isVisSPC || this.context?.isVisSPC === "" || this.context?.isVisSPC === "spc") ? classNames(classes.contentPaddingLeft, this.state.sidebarHover && classes.contentPaddingLeftHover)
              : ""
          )}
          id="mainContent"
          onTransitionEnd={this.aoTerminarTransicao}
        >
          <Decoration mode={mode} gradient={gradient} decoration={deco} bgPosition={bgPosition} horizontalMenu={false} />
          <section className={classNames(classes.mainWrap, classes.sidebarLayout)}>
            {titleException.indexOf(history.location.pathname) < 0 && (
              <div className={classes.pageTitle}>
                <Typography
                  component="h1"
                  className={bgPosition === "header" ? classes.darkTitle : classes.lightTitle}
                  variant="h4"
                >
                  {place}
                </Typography>
              </div>
            )}
            {!true && <img src="/images/spinner.gif" alt="spinner" className={classes.circularProgress} />}
            <Fade in={true} mountOnEnter unmountOnExit {...(true ? { timeout: 700 } : {})} style={{ overflow: "auto" }}>
              <div className={!true ? classes.hideApp : ""}>
                {/* Application content will load here */}
                {children}
              </div>
            </Fade>
          </section>
        </main>
      </Fragment>
    );
  }
}

// const mapStateToProps = (state: IState) => {
//   return {
//     sidebarOpen: state.ui.sidebarOpen
//   };
// };

// const LeftSidebarLayoutMaped = connect(mapStateToProps, null)(LeftSidebarLayout);

export default withStyles(styles as any)(withRouter(LeftSidebarLayout));
